// add this import near the top with the others
import './ai-modal.css';
// add this import near the top with the others
// route_analysis, DeliveryActivity and Analytics are no longer routed
// directly — they now live as tabs inside DeliveryAnalyticsPage.js, which
// imports them itself.
import API_BASE from "./apiBase";

import React, { useState, useMemo, useRef, useEffect } from "react";
import Login from "./Login";
import QMap from "./QMap";
import Stafflogin from './stafflogin';
import Sitedetails from './sitedetails';
import DriverRoute from "./driverroute";
import HeadOffice from "./HeadOffice"; // <-- added: fleet dashboard
import FleetMap from "./FleetMap"; // <-- added: standalone ?fleetmap=1 tab
import Organisation from "./Organisation";
import DashboardPanels from "./DashboardPanels";
import TrackPage from "./TrackPage";
import OrgSettings from "./OrgSettings"; // <-- added: single-pharmacy view
import Customers from "./Customers";
// Locations.js is no longer routed directly — its screen now lives as a tab
// inside Organisation.js ("Configuration" in the rail), which imports it.
import Communications from "./Communications"; // <-- added: staff/manager push notification settings
import Navigator from "./Navigator"; // <-- added: floating "where am I / how do I" panel
import Staff from "./Staff"; // <-- added: staff roster + appraisals
import HolidayRota from "./holiday_rota"; // <-- added: per-branch holiday/absence rota
import DeliveryAnalyticsPage from "./DeliveryAnalyticsPage"; // <-- added: Analytics / Summary / Delivery rounds, tabbed
import Workforce from "./Workforce"; // <-- added: hours per 1000 items grid
import Config from "./Config"; // <-- added: configurables admin
import SiteManagement from "./SiteManagement"; // <-- added: Admin > Site management (Pharmace all only)
import PharmacistRota from "./PharmacistRota"; // <-- added: pharmacist cover rota (beta)
import SupportChat from "./SupportChat"; // <-- added: Support chat button + panel, top-right

import QuestionBox from "./QuestionBox";
import "./App.css";
import "./theme.css";

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

/* ---------------------------------------------------------------------------
   NAVIGATION ICONS
   ---------------------------------------------------------------------------
   Inline SVG rather than an icon package: the platform deliberately carries no
   icon dependency (see NOTES), and fifteen line drawings are not worth a new
   one. Each entry is a list of paths on a 24x24 grid, stroked in the current
   text colour so an active or disabled item tints its icon for free.
   ------------------------------------------------------------------------ */
const ICONS = {
  parcel:   ["M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z", "M4 7.5l8 4.5 8-4.5", "M12 12v9"],
  building: ["M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16", "M15 10h4a1 1 0 0 1 1 1v10",
             "M3 21h18", "M8 8h3", "M8 12h3", "M8 16h3"],
  people:   ["M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20",
             "M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
             "M20 20v-1.5a3.5 3.5 0 0 0-2.6-3.4", "M15.5 4.2a3.5 3.5 0 0 1 0 6.6"],
  pin:      ["M12 21s7-5.2 7-11a7 7 0 1 0-14 0c0 5.8 7 11 7 11z",
             "M12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"],
  truck:    ["M3 16V6a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v10", "M14 9h3.5l2.5 3v4",
             "M6.5 19a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6z",
             "M17.5 19a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6z", "M8.5 17h7"],
  route:    ["M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", "M18 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
             "M16 7H9a3 3 0 0 0 0 6h6a3 3 0 0 1 0 6H8"],
  bars:     ["M3 20h18", "M7 20v-6", "M12 20V6", "M17 20v-9"],
  panels:   ["M3 3h8v6H3z", "M13 3h8v10h-8z", "M3 12h8v9H3z", "M13 16h8v5h-8z"],
  file:     ["M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z",
             "M14 3v4h4", "M9 13h6", "M9 17h6"],
  sliders:  ["M4 6h10", "M18 6h2", "M4 12h4", "M12 12h8", "M4 18h10", "M18 18h2",
             "M14 4v4", "M8 10v4", "M14 16v4"],
  message:  ["M20 15a2 2 0 0 1-2 2H8l-4 3V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"],
  clipboard:["M9 4h6v3H9z", "M7 5H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1",
             "M9 12h6", "M9 16h4"],
  database: ["M12 3c4.4 0 8 1.1 8 2.5S16.4 8 12 8 4 6.9 4 5.5 7.6 3 12 3z",
             "M4 5.5v13C4 19.9 7.6 21 12 21s8-1.1 8-2.5v-13", "M4 12c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5"],
  trash:    ["M4 7h16", "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2",
             "M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13", "M10 11v6", "M14 11v6"],
  compass:  ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M15.5 8.5l-2 5-5 2 2-5z"],
  logout:   ["M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4", "M9 16l-4-4 4-4", "M5 12h11"],
  menu:     ["M4 7h16", "M4 12h16", "M4 17h16"],
  chevron:  ["M9 6l6 6-6 6"],
  // A speech bubble with a "?" — distinct from `message` (used for
  // Communications) so the two buttons don't read as the same feature.
  support:  ["M20 15a2 2 0 0 1-2 2H8l-4 3V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z",
             "M9.5 9.2a1.9 1.9 0 1 1 2.9 1.6c-.6.4-1 .8-1 1.6",
             "M11.4 14.4h.02"]
};

const Ic = ({ name, size = 18, className = "pd-nav-icon" }) => {
  const paths = ICONS[name];
  if (!paths) return null;
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24"
         fill="none" stroke="currentColor" strokeWidth="1.7"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
         focusable="false" style={{ flexShrink: 0 }}>
      {paths.map((d, i) => <path key={i} d={d} />)}
    </svg>
  );
};

/* Breadcrumb wording. Keys are `currentView` values, so a route that is only
   reachable from inside another screen (customers, staff, the rota family)
   still names itself properly in the trail. A view missing from here falls
   back to its route name rather than showing nothing. */
const VIEW_TRAIL = {
  head_office:       ["Delivery control"],
  organisation:      ["Configuration"],
  communications:    ["Communications"],
  customers:         ["Customers"],
  // route_analysis and delivery_activity are no longer reachable directly —
  // both are tabs inside "analytics" (DeliveryAnalyticsPage) now. Left here,
  // harmlessly unused, rather than deleted, in case something still deep
  // links to them.
  route_analysis:    ["Delivery analytics", "Delivery rounds"],
  delivery_activity: ["Delivery analytics", "Summary"],
  analytics:         ["Delivery analytics"],
  dashpanels:        ["Live monitoring panels"],
  config:            ["Configurables"],
  staff:             ["Staff"],
  holiday_rota:      ["Staff", "Holiday rota"],
  workforce:         ["Staff", "Workforce planner"],
  pharmacist_rota:   ["Staff", "Driver rota"],
  stafflogin:        ["Staff", "Logins"],
  sitedetails:       ["Site details"],
  org_settings:      ["Settings", "Organisation"],
  site_management:   ["Settings", "Site management"]
};

const App = () => {
  // PUBLIC tracking page, before anything that needs a sign-in: a customer
  // arriving from an email at #/track/<key> sees their parcel and nothing
  // else. A hash route needs no server rewrite, which matters on Plesk.
  const trackMatch = /^#\/track\/([0-9a-f]{32})$/.exec(window.location.hash || "");
  if (trackMatch) return <TrackPage token={trackMatch[1]} />;

  // The read-only /?spview=TOKEN share link was removed with the Single
  // pharmacy screen it was minted from. The idea is worth rebuilding against
  // Head Office — a no-login, view-only URL for one branch is useful — but it
  // needs a screen to point at first.
  return <AuthedApp />;
};

const AuthedApp = () => {
  const [token, setToken] = useState(localStorage.getItem("token"));

  // Rehydrated from storage, not left null.
  //
  // A refresh restores `token`, so the app considers you signed in — but
  // userData is only ever set by the login form, so without this every screen
  // that reads a name, role or branch got nothing after F5 and the session
  // looked half-broken.
  const [userData, setUserData] = useState(() => {
    const stored = localStorage.getItem("userId");
    if (!stored) return null;
    return {
      id: stored,
      name: localStorage.getItem("userName") || "",
      email: localStorage.getItem("userEmail") || "",
      role: (localStorage.getItem("roleKey") || "").toLowerCase(),
      accountId: localStorage.getItem("currentAccountId") || "",
      groupId: localStorage.getItem("groupId") || "",
      organisationName: localStorage.getItem("organisationName") || "",
    };
  });
  const [currentView, setCurrentView] = useState("head_office");
  const [answer, setAnswer] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [loadingAnswer, setLoadingAnswer] = useState(false);
  const [clarificationOptions, setClarificationOptions] = useState(null);
  const [selectedPharmacy, setSelectedPharmacy] = useState("");
  const [selectedMetric, setSelectedMetric] = useState("");
  const [showStockMenu, setShowStockMenu] = useState(false);

  // Unified state for the categorised dropdown menus.
  // Only one dropdown is open at a time. Click-outside closes it.
  const [openMenu, setOpenMenu] = useState(null); // "delivery" | "operations" | "settings" | null
  const navRef = useRef(null);

  // Nav item style for the left sidebar.
  //
  // NOTE THE ABSENT BACKGROUND. index.css paints every bare <button> blue, so
  // an inline style is still needed to beat it - but the resting and hover
  // backgrounds are set in theme.css instead, because an inline background
  // cannot be overridden by a :hover rule. Only the ACTIVE item sets one
  // inline, which is exactly what stops a hover from painting over the
  // current selection.
  const navBtnStyle = {
    display: "flex",
    alignItems: "center",
    gap: 10,
    width: "100%",
    padding: "9px 11px",
    border: "none",
    borderRadius: 8,
    color: "#475467",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.25,
    textAlign: "left",
    cursor: "pointer"
  };

  // ---------------------------------------------------------------------------
  // ACTIVE RAIL HIGHLIGHTING
  // ---------------------------------------------------------------------------
  // Which flyout owns which routes, so a parent ("Stock", "Delivery") lights up
  // when you are inside one of its children. Keys match the openMenu values.
  const NAV_GROUPS = {
    settings: ["config", "sitedetails", "site_management"]
  };

  // navBtn(view, extra) — the rail style with an active variant.
  //
  // The active look is a blue left edge plus a pale blue wash. Several rail
  // buttons carry a meaningful colour of their own (Custom panels is amber);
  // that colour is preserved when the item is selected, with the blue edge
  // sitting on top of it, so both signals survive.
  const navBtn = (view, extra = {}) => {
    // `view` may be a route name, a list of route names, or a plain boolean —
    // the last for buttons that open a dialog rather than change currentView
    // (Settings, Stock Shelves), which are just as much "where you are".
    const on = typeof view === "boolean"
      ? view
      : Array.isArray(view) ? view.includes(currentView) : currentView === view;
    if (!on) return { ...navBtnStyle, ...extra };
    return {
      ...navBtnStyle,
      ...extra,
      fontWeight: 600,
      color: extra.color || "#1560ac",
      backgroundColor: extra.backgroundColor || extra.background || "#e8f1fd",
      background: extra.background || extra.backgroundColor || "#e8f1fd",
      // The selected marker is an inset shadow, not a border, so it costs no
      // width: a bordered item would shift its label sideways on selection,
      // and items carrying a colour of their own (the panels button is amber)
      // keep that colour underneath.
      boxShadow: "inset 3px 0 0 #1976d2"
    };
  };

  // Same treatment for a flyout parent whose child route is the current view.
  const navGroupBtn = (groupKey, extra = {}) => navBtn(NAV_GROUPS[groupKey] || [], extra);

  // Navigator — the floating "where am I / how do I" panel at the foot of the
  // rail. Kept in App because it needs currentView and goTo, and because it must
  // outlive any single view: it stays open while you follow its instructions.
  const [navigatorOpen, setNavigatorOpen] = useState(false);

  // Sidebar collapse. Remembered per browser: someone working on a laptop
  // wants the narrow rail every time, not once.
  const [navCollapsed, setNavCollapsed] = useState(
    () => localStorage.getItem("navCollapsed") === "1"
  );
  const toggleNav = () => setNavCollapsed(c => {
    try { localStorage.setItem("navCollapsed", c ? "0" : "1"); } catch (_) {}
    return !c;
  });

  // Chrome text. userData is rehydrated from storage above, but a screen may
  // be open before it lands, so storage is the fallback for both.
  const orgName  = localStorage.getItem("organisationName") || "Your group";
  const userName = (userData && userData.name) || localStorage.getItem("userName") || "";
  const initials = (userName.trim().split(/\s+/).filter(Boolean).slice(0, 2)
    .map(w => w[0]).join("") || "?").toUpperCase();

  useEffect(() => {
    function handleClickOutside(e) {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Support chat (top-right button). The badge count is polled the whole
  // time someone is signed in, independent of which screen they're on and
  // whether the panel itself is open — SupportChat.js runs its own faster
  // poll for the conversation only while the panel is actually open.
  const [supportOpen, setSupportOpen] = useState(false);
  const [supportUnread, setSupportUnread] = useState(0);
  useEffect(() => {
    if (!token) return undefined;
    let alive = true;
    const poll = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/support/unread-count`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        if (alive) setSupportUnread(Number(data?.unread || 0));
      } catch (_) {
        // A failed poll just tries again next interval — no need to surface
        // a network hiccup as an error for a background badge count.
      }
    };
    poll();
    const timer = setInterval(poll, 45000);
    return () => { alive = false; clearInterval(timer); };
  }, [token]);

  // Communications badge — the persistent "N unread" indicator in the top
  // bar, combining driver and customer incoming messages into one number so
  // it's visible on every page, not just the Communications one. Same
  // poll-every-45s pattern as Support just above it.
  const [commsSummary, setCommsSummary] = useState(null);
  useEffect(() => {
    if (!token) return undefined;
    let alive = true;
    const poll = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/comms/summary`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        if (alive) setCommsSummary(data);
      } catch (_) {
        // Same reasoning as the support poll above — silent retry, not an
        // error banner for a background badge.
      }
    };
    poll();
    const timer = setInterval(poll, 45000);
    return () => { alive = false; clearInterval(timer); };
  }, [token]);
  // The combined total (commsUnread) that used to feed one shared badge
  // is gone — StaffMessagingCard/CustomerMessagingCard on the dashboard
  // and the two badges just above both read commsSummary.drivers/
  // .customers directly now that there are two of them, not one.

  // Helper: choose a view and close any open dropdown.
  // navEpoch increments on EVERY rail click and keys the rendered view, so
  // clicking a menu button always lands fresh at that section's top level —
  // including re-clicking the section you are already in (previously a
  // silent no-op: setCurrentView with the same value doesn't re-render, so
  // deep drill-down state inside the section appeared "stuck").
  const [navParams, setNavParams] = useState(null);
  const [navEpoch, setNavEpoch] = useState(0);
  const goTo = (view, params = null) => {
    setCurrentView(view);
    setNavParams(params);
    setNavEpoch(e => e + 1);
    setOpenMenu(null);
  };

  // Pagination & Sorting & Filtering
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;
  const [sortKey, setSortKey] = useState("");
  const [sortAsc, setSortAsc] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [question, setQuestion] = useState("");

  /* ---------------------------------------------------------------------------
     "Appraisal embedded" (menu button; Pharmace all + Southtown Group only).
     Opens the standalone embeddable-appraisal page on pharmaceinstall:
       https://pharmaceinstall.co.uk/appraisals.html?key=wk_...
     The full widget key is only returned once at creation (the list endpoint
     returns tails), so the first click creates a dedicated demo key for the
     'Demo Live' pharmacy (origin-locked to pharmaceinstall) and the finished
     link is remembered in this browser (localStorage) for every later click.
     --------------------------------------------------------------------------- */
  const APPRAISAL_DEMO_LS = "appraisal_embedded_demo_url";
  const [appraisalDemoBusy, setAppraisalDemoBusy] = useState(false);
  const appraisalDemoVisible = ["pharmace all", "southtown group"]
    .includes((localStorage.getItem("organisationName") || "").trim().toLowerCase());

  const openAppraisalEmbeddedDemo = async () => {
    const saved = localStorage.getItem(APPRAISAL_DEMO_LS) || "";
    if (saved.startsWith("https://pharmaceinstall.co.uk/appraisals.html?key=wk_")) {
      window.open(saved, "_blank", "noopener");
      return;
    }
    let members = [];
    try { members = JSON.parse(localStorage.getItem("members")) || []; } catch (_) {}
    // The demo is always keyed to the 'Demo Live' pharmacy; fall back to the
    // first pharmacy only if Demo Live isn't a member of this organisation.
    const demoMember = members.find(m => String(m?.pharmacyName || "").trim().toLowerCase() === "demo live");
    const targetName = demoMember?.pharmacyName || members[0]?.pharmacyName || "";
    if (!targetName) { window.alert("No pharmacy found on this organisation to demo with."); return; }
    if (!window.confirm(
      `Open the embedded appraisal demo?\n\nThis creates a demo widget key for "${targetName}"` +
      (demoMember ? "" : " (no 'Demo Live' pharmacy was found, so the first pharmacy is used)") +
      ` — locked to pharmaceinstall.co.uk — and opens the standalone appraisal page with it. ` +
      `The link is remembered in this browser for next time.`)) return;
    setAppraisalDemoBusy(true);
    try {
      const res = await fetch(`${API_BASE}/api/appraisals/widget-keys/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken") || localStorage.getItem("token")}`
        },
        body: JSON.stringify({
          pharmacyName: targetName,
          label: "Appraisal embedded demo (menu)",
          allowedOrigins: ["https://pharmaceinstall.co.uk"],
          issuedBy: { name: localStorage.getItem("userName") || "", roleKey: localStorage.getItem("roleKey") || "GROUP_MANAGER" }
        })
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || `HTTP ${res.status}`);
      const url = `https://pharmaceinstall.co.uk/appraisals.html?key=${d.key}`;
      try { localStorage.setItem(APPRAISAL_DEMO_LS, url); } catch (_) {}
      window.open(url, "_blank", "noopener");
    } catch (e) { window.alert(`Could not open the demo: ${e.message}`); }
    finally { setAppraisalDemoBusy(false); }
  };

  /* ---------------------------------------------------------------------------
     "Insert demo data" (menu button; Southtown Group only). Calls the backend
     demo seeder (POST /api/demoseed/run), which INSERTS artificial:true demo
     records into the four hardcoded test databases, high-water-mark style:
       - continues each staff member's clock history from their last seeded day
       - TODAY gets clock-in-only sessions (staff haven't left yet)
       - any earlier artificial sessions still missing a clock-out are closed
         retrospectively ("orphan cleanup")
     The server re-checks the organisation, so the button is cosmetic gating
     only; nothing outside the four test databases can ever be written.
     --------------------------------------------------------------------------- */
  const [demoSeedBusy, setDemoSeedBusy] = useState(false);
  const demoSeedVisible = (localStorage.getItem("organisationName") || "").trim().toLowerCase() === "southtown group";

  const runDemoSeed = async () => {
    if (!window.confirm(
      "Refresh demo data in the four Southtown test sites?\n\n" +
      "CLOCK IN/OUT HISTORY IS REPLACED. Existing demo clock sessions and break logs for " +
      "the seeding window are DELETED and regenerated, so a re-run reflects the current " +
      "generator rather than adding a second batch alongside the first.\n\n" +
      "Everything else is insert-only and left as it is: staff, roles, schedules, " +
      "appraisals, pre-appraisals and 12-month reviews. Staff records keep their ids, so " +
      "appraisal history survives.\n\n" +
      "Only records flagged artificial:true are ever deleted - real clockings in those " +
      "test sites are untouched, and days that already hold a real clocking are skipped.\n\n" +
      "Today's sessions get a clock-in only (staff are still on site).\n\nProceed?")) return;
    setDemoSeedBusy(true);
    try {
      const res = await fetch(`${API_BASE}/api/demoseed/run`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken") || localStorage.getItem("token")}`
        },
        body: JSON.stringify({ mode: "seed" })
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || `HTTP ${res.status}`);
      const t = d.totals || {};
      window.alert(
        "Demo data refreshed across the four test sites:\n\n" +
        `Clock sessions replaced: ${t.attendanceDeleted || 0} deleted, ${t.attendance || 0} regenerated\n` +
        `  (of which ${t.todayPartials || 0} are today's clock-in-only)\n` +
        `Break logs: ${t.breaksDeleted || 0} deleted, ${t.breaks || 0} regenerated\n` +
        (t.attendanceKeptOlder
          ? `Older than the seeding window, left alone: ${t.attendanceKeptOlder}\n`
          : "") +
        `Orphan sessions closed: ${t.orphansClosed || 0}\n\n` +
        "Left as they were (insert-only):\n" +
        `Staff created: ${t.staffCreated || 0} | Schedule rows: ${t.timesDocs || 0}\n` +
        `Appraisals: ${t.appraisals || 0} | Pre-appraisals: ${t.preappraisals || 0} | 12-month reviews: ${t.reviews || 0}\n` +
        `Holiday requests: ${t.leaveRequests || 0} (${t.leaveApproved || 0} approved, ` +
        `${t.leaveRejected || 0} rejected, ${t.leavePending || 0} awaiting)\n` +
        `Absences: ${t.absences || 0} spells over ${t.absenceDays || 0} days\n` +

        "Only artificial:true records were deleted.");
    } catch (e) { window.alert(`Demo data insert failed: ${e.message}`); }
    finally { setDemoSeedBusy(false); }
  };

  /* ---------------------------------------------------------------------------
     "Wipe demo data" — the same endpoint in wipe mode.
     Exists because the CLI cannot be used on this host: the Mongo connection
     strings live inside server.js rather than in an .env the script can read,
     so `node seed_southtown_demo.js --wipe` falls back to localhost and is
     refused. In-process is the only way to reach a wipe.
     Deletes ONLY artificial:true records, and only in the four hardcoded test
     databases — the server re-checks both, so this button is cosmetic gating.
     --------------------------------------------------------------------------- */
  const [demoWipeBusy, setDemoWipeBusy] = useState(false);

  const runDemoWipe = async () => {
    if (!window.confirm(
      "Delete ALL demo data from the four Southtown test sites?\n\n" +
      "Removes artificial:true staff, schedules, clock sessions, break logs, " +
      "appraisals, pre-appraisals, reviews, holiday requests, absences and " +
      "goods-in invoices.\n\n" +
      "Real records are never touched: every delete is filtered on " +
      "artificial:true, and nothing outside the four test databases is opened.\n\n" +
      "Invoices raised by hand in the app carry no artificial flag and will " +
      "SURVIVE this.\n\nProceed?")) return;
    setDemoWipeBusy(true);
    try {
      const res = await fetch(`${API_BASE}/api/demoseed/run`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken") || localStorage.getItem("token")}`
        },
        body: JSON.stringify({ mode: "wipe" })
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || `HTTP ${res.status}`);
      const lines = (d.report || []).map((r) => {
        const cols = Object.entries(r)
          .filter(([k, v]) => k !== "dbName" && typeof v === "number" && v > 0)
          .map(([k, v]) => `  ${k}: ${v}`);
        return `${r.dbName}\n${cols.length ? cols.join("\n") : "  nothing to delete"}`;
      });
      window.alert("Demo data wiped.\n\n" + lines.join("\n\n") +
        "\n\nOnly artificial:true records were deleted. " +
        "Use Insert demo data to regenerate.");
    } catch (e) { window.alert(`Demo data wipe failed: ${e.message}`); }
    finally { setDemoWipeBusy(false); }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken(null);
  };

  const handleAskQuestion = async (question) => {
    if (!question.trim()) return;
    setQuestion(question);
    setLoadingAnswer(true);
    setClarificationOptions(null);
    setAnswer("");
    setCurrentPage(1);
    const members = JSON.parse(localStorage.getItem("members") || "[]");
    try {
      const res = await fetch(`${API_BASE}/aiquery`, {
        method: "POST",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
        body: JSON.stringify({ question, members })
      });

      if (!res.ok) {
        console.error("Server returned an error status:", res.status);
        setAnswer(`Server error: ${res.status}`);
        setShowDialog(true);
        return;
      }

      const data = await res.json();
      if (data.needClarification) {
        setClarificationOptions({
          message: data.message,
          missingFields: data.missingFields
        });
        return;
      }

      setAnswer(data.answer || "No response received.");
      setShowDialog(true);

      await fetch(`${API_BASE}/savequestion`, {
        method: "POST",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
        body: JSON.stringify({
          groupId: localStorage.getItem("userId"),
          question
        })
      });
    } catch (error) {
      console.error("Error during /aiquery fetch:", error);
      setAnswer("An error occurred while fetching data.");
      setShowDialog(true);
    } finally {
      setLoadingAnswer(false);
    }
  };

  const handleClarifiedQuery = async () => {
    if (!selectedPharmacy || !selectedMetric) return;
    const newQuestion = `What is the ${selectedMetric} at ${selectedPharmacy}?`;
    await handleAskQuestion(newQuestion);
  };


  const handleExportToExcel = () => {
    if (!Array.isArray(answer) || answer.length === 0) return;

    const exportData = answer.map(item => {
      const filtered = {};
      for (const [key, value] of Object.entries(item)) {
        if (["_id", "log"].includes(key)) continue;
        if (["price", "value", "totalPrice", "totalValue"].includes(key) && typeof value === "number") {
          filtered[key] = (value / 100).toFixed(2);
        } else {
          filtered[key] = value;
        }
      }
      return filtered;
    });

    import("xlsx").then((xlsx) => {
      const workbook = xlsx.utils.book_new();
      const worksheet = {};

      const groupName = localStorage.getItem("organisationName") || "Group";
      const now = new Date();
      const formatted = now.toLocaleString("en-GB", {
        day: "2-digit", month: "2-digit", year: "2-digit",
        hour: "2-digit", minute: "2-digit"
      });
      const questionPrompt = question || "";

      const headerRows = [
        [groupName],
        [`Generated at: ${formatted}`],
        [`Prompt: ${questionPrompt}`],
        []
      ];
      xlsx.utils.sheet_add_aoa(worksheet, headerRows, { origin: "A1" });

      const headers = Object.keys(exportData[0] || {});
      xlsx.utils.sheet_add_aoa(worksheet, [headers], { origin: "A5" });

      xlsx.utils.sheet_add_json(worksheet, exportData, {
        origin: "A6",
        skipHeader: true
      });

      const allRows = [...headerRows, headers, ...exportData.map(obj => headers.map(k => obj[k] ?? ""))];
      worksheet["!cols"] = headers.map((_, colIdx) => {
        const maxLength = allRows.reduce((max, row) => {
          const val = row[colIdx];
          const len = val ? String(val).length : 0;
          return Math.max(max, len);
        }, 10);
        return { wch: maxLength + 2 };
      });

      xlsx.utils.book_append_sheet(workbook, worksheet, "AI_Results");
      xlsx.writeFile(workbook, "AI_Response.xlsx");
    });
  };

  const filteredAndSorted = useMemo(() => {
    if (!Array.isArray(answer)) return [];

    let result = [...answer];

    if (filterText) {
      result = result.filter(row =>
        Object.values(row).some(val =>
          String(val).toLowerCase().includes(filterText.toLowerCase())
        )
      );
    }

    if (sortKey) {
      result.sort((a, b) => {
        const valA = a[sortKey];
        const valB = b[sortKey];
        if (valA == null) return 1;
        if (valB == null) return -1;
        if (typeof valA === "number" && typeof valB === "number") {
          return sortAsc ? valA - valB : valB - valA;
        }
        return sortAsc
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      });
    }

    return result;
  }, [answer, filterText, sortKey, sortAsc]);

  const totalPages = Math.ceil(filteredAndSorted.length / pageSize);
  const paginatedAnswer = filteredAndSorted.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  // ---- wall display -------------------------------------------------------
  // ?wall=<dashboardId> renders one dashboard and nothing else: no menu, no
  // header, no chrome. This is for a screen on the wall, so anything that is
  // not the panels is wasted pixels - and there is nothing to click by
  // accident. The token still comes from localStorage, which is shared across
  // tabs on the same origin, so the new tab is already signed in.
  const wallDash = new URLSearchParams(window.location.search).get("wall");
  if (wallDash && token) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DashboardPanels wallDashboardId={wallDash} />
      </LocalizationProvider>
    );
  }

  // ?fleetmap=1 — the fleet map, full screen, in its own tab: no menu, no
  // header, no dashboard cards. "Move to new screen" on the map opens this
  // rather than toggling an in-page overlay, so the map can go on its own
  // monitor while the rest of Head Office stays open where it was. Same
  // shared-localStorage-token trick as the dashboard wall view above.
  const fleetMapStandalone = new URLSearchParams(window.location.search).get("fleetmap");
  if (fleetMapStandalone && token) {
    return <FleetMap token={token} standalone />;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="app-container">
        {!token ? (
          <Login setToken={setToken} setUserData={setUserData} />
        ) : (
          <>
            {/* ═══════════════════════════════════════════════════════════
                THE SHELL
                ═══════════════════════════════════════════════════════════
                Fixed sidebar, thin top bar, breadcrumb line, content area.
                Structure only - every button below keeps the handler, title
                and visibility condition it had in the old rail, and the
                #section-header-slot still exists (HeadOffice portals its
                heading and toolbar into it), it has simply moved onto the
                breadcrumb line where a section's own controls belong.
                ═══════════════════════════════════════════════════════════ */}
            <div className="pd-shell">

              {/* ── Sidebar ─────────────────────────────────────────────── */}
              <aside
                ref={navRef}
                className={"pd-sidebar" + (navCollapsed ? " is-collapsed" : "")}
              >
                <div className="pd-brand" title={orgName}>
                  <span className="pd-brand-mark">
                    <Ic name="parcel" size={17} className="pd-ic" />
                  </span>
                  <div className="pd-brand-text">
                    <div className="pd-brand-name">Delivery</div>
                    <div className="pd-brand-sub">{orgName}</div>
                  </div>
                </div>

                <nav className="pd-nav">
                  {/* Delivery control — fleet dashboard for /api/headoffice/* — default landing page */}
                  <button onClick={() => goTo("head_office")} style={navBtn("head_office")}
                    title="A live 'how am I driving?' dashboard — current, real-time status across the whole fleet at a glance.">
                    <Ic name="building" />
                    <span className="pd-nav-label">Delivery control</span>
                  </button>

                  {/* Delivery analytics — Analytics, Summary (was Activity) and
                      Delivery rounds (was Route analysis), tabbed on one
                      screen. Sits right under Delivery control since the two
                      are read together most days. */}
                  <button onClick={() => goTo("analytics")} style={navBtn("analytics")}
                    title="Delivery analytics — deliveries per day by branch, failed deliveries and average delivery time (Analytics); deliveries, mileage and time by site and driver (Summary); and driver route efficiency (Delivery rounds).">
                    <Ic name="bars" />
                    <span className="pd-nav-label">Delivery analytics</span>
                  </button>

                  {/* Communications moved off the left nav (Sept 2026) —
                      now reached via the Communications card on the
                      dashboard's "Customers, Drivers and Vehicles" row, or
                      the persistent unread badge in the top bar. The route
                      itself (goTo("communications")) is unchanged; only the
                      menu entry into it is gone, so nothing else that links
                      here needs touching. */}

                  {/* Inspection menu button removed per request (2026-07). The
                      "inspection" route and the Inspection component remain
                      intact — restore this block to bring the menu entry back.
                  */}

                  {/* Delivery flyout removed — Route analysis, Activity and
                      Analytics are now tabs on the single "Delivery analytics"
                      top-level button above (see DeliveryAnalyticsPage.js).
                      The three underlying screens are unchanged; only the
                      menu structure around them moved. */}

                  {/* Staff flyout removed per request — Workforce planner,
                      Staff clocking in/out (Raw data) and Pharmacist rota now
                      live as tabs inside Head Office -> Staff -> Clock in/out.
                      The components and their currentView routes below remain
                      intact; restore this block to bring the menu back. */}

                  {/* Dashboard panels — AI-assisted, user-composed dashboards.
                      Keeps its amber identity in the new palette: the tint is
                      quieter, but it is still the one item that is not a
                      standard destination. */}
                  <button onClick={() => goTo("dashpanels")}
                    style={navBtn("dashpanels", { background: "#fff7e6", backgroundColor: "#fff7e6", color: "#92400e", fontWeight: 600 })}
                    title="Custom live monitoring panels — built from plain-English descriptions of deliveries, collections, rounds and attempts, refreshed on your chosen interval, arrangeable and saveable as named dashboards.">
                    <Ic name="panels" />
                    <span className="pd-nav-label">Live monitoring panels</span>
                  </button>

                  {/* Settings button removed 25 Aug 2026: the dialog it opened
                      (organisation settings, site settings, configurables,
                      staff notification settings) was the pharmacy platform's
                      and nothing in the delivery product reads any of it. The
                      `org_settings` route below is left intact. */}

                  {/* SOP Upload and Configurables were orphaned by the folder's
                      removal, so they sit at top level — Pharmace all only. */}
                  {(localStorage.getItem("organisationName") || "").trim() === "Pharmace all" && (
                    <>
                      <div className="pd-nav-heading">Admin</div>
                      {/* SOP Upload — DISABLED (button retained for later re-enable;
                          the sop_upload view render below is left intact). */}
                      <button disabled style={{ ...navBtnStyle, opacity: 0.45, cursor: "not-allowed" }}
                        title="SOP upload is currently disabled.">
                        <Ic name="file" />
                        <span className="pd-nav-label">SOP Upload</span>
                      </button>
                      <button onClick={() => goTo("config")} style={navBtn("config")}
                        title="Configurables — admin-editable values used across the platform.">
                        <Ic name="sliders" />
                        <span className="pd-nav-label">Configurables</span>
                      </button>
                    </>
                  )}

                  {/* Appraisal embedded demo — Pharmace all + Southtown Group only.
                      Right-click offers a reset of the remembered demo link. */}
                  {appraisalDemoVisible && (
                    <button onClick={openAppraisalEmbeddedDemo} disabled={appraisalDemoBusy}
                      onContextMenu={(e) => {
                        e.preventDefault();
                        if (!localStorage.getItem(APPRAISAL_DEMO_LS)) { window.alert("No demo link is stored in this browser."); return; }
                        if (window.confirm("Forget the stored demo link?\n\nThe next click will create a fresh demo key. The old key stays valid until revoked in Settings \u2192 Site Settings (label: 'Appraisal embedded demo').")) {
                          localStorage.removeItem(APPRAISAL_DEMO_LS);
                        }
                      }}
                      style={{ ...navBtnStyle, opacity: appraisalDemoBusy ? 0.6 : 1 }}
                      title="Opens a live example of the embeddable staff appraisal package \u2014 the standalone webpage a branch site would host, keyed to the Demo Live pharmacy. Right-click to reset the stored demo link.">
                      <Ic name="clipboard" />
                      <span className="pd-nav-label">
                        {appraisalDemoBusy ? "Appraisal embedded\u2026" : "Appraisal embedded"}
                      </span>
                    </button>
                  )}

                  {/* Demo data seeder - Southtown Group only, with confirmation */}
                  {demoSeedVisible && (
                    <button onClick={runDemoSeed} disabled={demoSeedBusy}
                      style={{ ...navBtnStyle, opacity: demoSeedBusy ? 0.6 : 1 }}
                      title="Insert artificial demo data (staff, schedules, clock sessions, appraisals) into the four Southtown test sites. Insert-only; every record is flagged artificial:true. Today's sessions get a clock-in only; earlier open demo sessions are closed.">
                      <Ic name="database" />
                      <span className="pd-nav-label">
                        {demoSeedBusy ? "Inserting demo data\u2026" : "Insert demo data"}
                      </span>
                    </button>
                  )}

                  {/* Wipe — same endpoint, wipe mode. Only artificial:true rows,
                      only the four test databases. */}
                  {demoSeedVisible && (
                    <button onClick={runDemoWipe} disabled={demoWipeBusy || demoSeedBusy}
                      style={{ ...navBtnStyle, opacity: (demoWipeBusy || demoSeedBusy) ? 0.6 : 1 }}
                      title="Delete all artificial:true demo data from the four Southtown test sites. Real records and anything outside those four databases are never touched. Run Insert demo data afterwards to regenerate.">
                      <Ic name="trash" />
                      <span className="pd-nav-label">
                        {demoWipeBusy ? "Wiping demo data\u2026" : "Wipe demo data"}
                      </span>
                    </button>
                  )}

                  {/* Configuration — the group, its branches, its people, and
                      (as of the Locations-and-messaging move) its shelves,
                      totes and customer messaging, all as tabs on one screen.
                      Kept at the very bottom of the rail: standing setup you
                      visit rarely, not a daily destination. */}
                  <button onClick={() => goTo("organisation")} style={navBtn("organisation")}
                    title="Configuration — your branches, your people, and your locations and messaging settings.">
                    <Ic name="people" />
                    <span className="pd-nav-label">Configuration</span>
                  </button>
                </nav>

                {/* ── Navigator + sign out ──────────────────────────────────
                    Pinned below the menu, separated by a rule, so the
                    Navigator reads as a tool rather than another destination —
                    it changes nothing about where you are — and Log out is
                    always in the same place whatever the menu is doing. */}
                <div className="pd-nav-footer">
                  <button
                    onClick={() => setNavigatorOpen(o => !o)}
                    style={navBtn(navigatorOpen)}
                    title="Opens a small floating panel that explains where you are and answers 'how do I…' questions. You can drag it out of the way and it stays open while you follow the steps.">
                    <Ic name="compass" />
                    <span className="pd-nav-label">
                      {navigatorOpen ? "Hide navigator" : "Show navigator"}
                    </span>
                  </button>

                  <button onClick={handleLogout} style={navBtnStyle}
                    title="Log out of the management platform.">
                    <Ic name="logout" />
                    <span className="pd-nav-label">Log out</span>
                  </button>
                </div>
              </aside>

              {/* ── Main column ─────────────────────────────────────────── */}
              <div className={"pd-main" + (navCollapsed ? " is-wide" : "")}>

                <header className="pd-topbar">
                  <button className="pd-icon-btn" onClick={toggleNav}
                    aria-label={navCollapsed ? "Expand the menu" : "Collapse the menu"}
                    title={navCollapsed ? "Expand the menu" : "Collapse the menu"}>
                    <Ic name="menu" size={20} className="pd-ic" />
                  </button>

                  <div className="pd-topbar-spacer" />

                  <button className="pd-icon-btn pd-support-btn"
                    onClick={() => goTo("communications", { tab: "drivers" })}
                    aria-label={commsSummary?.drivers?.unread > 0
                      ? `Staff messages — ${commsSummary.drivers.unread} unread`
                      : "Staff messages"}
                    title="Staff messaging — driver messages, push or email.">
                    <Ic name="truck" size={20} className="pd-ic" />
                    {commsSummary?.drivers?.unread > 0 && (
                      <span className="pd-support-badge">
                        {commsSummary.drivers.unread > 99 ? "99+" : commsSummary.drivers.unread}
                      </span>
                    )}
                  </button>

                  <button className="pd-icon-btn pd-support-btn"
                    onClick={() => goTo("communications", { tab: "customers" })}
                    aria-label={commsSummary?.customers?.unread > 0
                      ? `Customer messages — ${commsSummary.customers.unread} unread`
                      : "Customer messages"}
                    title="Customer messaging — customer messages, push or email.">
                    <Ic name="message" size={20} className="pd-ic" />
                    {commsSummary?.customers?.unread > 0 && (
                      <span className="pd-support-badge">
                        {commsSummary.customers.unread > 99 ? "99+" : commsSummary.customers.unread}
                      </span>
                    )}
                  </button>

                  <button className="pd-icon-btn pd-support-btn"
                    onClick={() => setSupportOpen(true)}
                    aria-label={supportUnread > 0
                      ? `Support — ${supportUnread} unread ${supportUnread === 1 ? "reply" : "replies"}`
                      : "Support"}
                    title="Support — chat with us">
                    <Ic name="support" size={20} className="pd-ic" />
                    {supportUnread > 0 && (
                      <span className="pd-support-badge">
                        {supportUnread > 99 ? "99+" : supportUnread}
                      </span>
                    )}
                  </button>

                  <div className="pd-user">
                    <div className="pd-user-lines">
                      <div className="pd-user-name">{userName || "Signed in"}</div>
                      <div className="pd-user-org">{orgName}</div>
                    </div>
                    <div className="pd-avatar" title={userName}>{initials}</div>
                  </div>
                </header>

                {supportOpen && (
                  <SupportChat
                    onClose={() => setSupportOpen(false)}
                    onReadAll={() => setSupportUnread(0)}
                  />
                )}

                {/* Breadcrumb line. The section header slot sits on it, so a
                    screen's own title and controls cost no extra row. */}
                <div className="pd-pagehead">
                  <div className="pd-crumbs">
                    <span>Home</span>
                    {(VIEW_TRAIL[currentView] || [currentView]).map((crumb, i, all) => (
                      <React.Fragment key={crumb + i}>
                        <span className="pd-crumb-sep">/</span>
                        <span className={i === all.length - 1 ? "pd-crumb-here" : undefined}>{crumb}</span>
                      </React.Fragment>
                    ))}
                  </div>
                  <div id="section-header-slot" className="pd-header-slot" />
                </div>

                <main className="pd-content">

            {clarificationOptions && (
              <div style={{ marginTop: 20 }}>
                <p>{clarificationOptions.message}</p>
                {clarificationOptions.missingFields.includes("pharmacy name") && (
                  <>
                    <label>Choose Pharmacy: </label>
                    <select value={selectedPharmacy} onChange={(e) => setSelectedPharmacy(e.target.value)}>
                      <option value="">--Select--</option>
                      <option value="Oxford Pharmacy">Oxford Pharmacy</option>
                      <option value="High Street Pharmacy">High Street Pharmacy</option>
                      <option value="City Centre Pharmacy">City Centre Pharmacy</option>
                    </select>
                  </>
                )}
                {clarificationOptions.missingFields.includes("metric") && (
                  <>
                    <label> Choose Metric: </label>
                    <select value={selectedMetric} onChange={(e) => setSelectedMetric(e.target.value)}>
                      <option value="">--Select--</option>
                      <option value="totalCost">Total Cost</option>
                      <option value="count">Count</option>
                      <option value="totalPackets">Total Packets</option>
                      <option value="averagePrice">Average Price</option>
                      <option value="expiringSoon">Expiring Soon</option>
                    </select>
                  </>
                )}
                <button
                  onClick={handleClarifiedQuery}
                  disabled={
                    (clarificationOptions.missingFields.includes("pharmacy name") && !selectedPharmacy) ||
                    (clarificationOptions.missingFields.includes("metric") && !selectedMetric)
                  }
                  style={{ marginLeft: "10px" }}
                >
                  Submit Clarified Query
                </button>
              </div>
            )}

            {/* Keyed on view+epoch: every rail click remounts the target view
                fresh at its top level (see goTo). display:"contents" keeps the
                wrapper out of the flex layout. */}
            <div key={`${currentView}-${navEpoch}`} style={{ display: "contents" }}>
            {currentView === "head_office" && <HeadOffice token={token} onNavigate={goTo} />}
            {currentView === "organisation" && <Organisation token={token} />}
            {currentView === "staff" && <Staff token={token} userData={userData} />}
            {currentView === "holiday_rota" && <HolidayRota token={token} userData={userData} />}
            {currentView === "workforce" && <Workforce token={token} userData={userData} />}
            {currentView === "pharmacist_rota" && <PharmacistRota />}
            {currentView === "config" && <Config token={token} />}
            {currentView === "stafflogin" && <Stafflogin userData={userData} />}
            {currentView === "customers" && <Customers token={token} />}
            {currentView === "analytics" && <DeliveryAnalyticsPage token={token} userData={userData} />}

            {currentView === "sitedetails" && <Sitedetails userData={userData} />}
            {currentView === "dashpanels" && <DashboardPanels />}
            {currentView === "org_settings" && <OrgSettings />}
            {currentView === "communications" && <Communications goTo={goTo} initialTab={navParams?.tab} />}
            {currentView === "site_management" && <SiteManagement />}
            </div>
                </main>
              </div>
            </div>

            {/* Rendered here, outside the layout flex and after the dialogs, so
                its fixed positioning is relative to the viewport and its stacking
                context is the document root — "always on top" only holds if it is
                not nested inside something with its own transform or z-index.
                Unmounted rather than hidden when closed: reopening should start
                from where you are now, not from a stale question. */}
            {navigatorOpen && (
              <Navigator
                currentView={currentView}
                goTo={goTo}
                onClose={() => setNavigatorOpen(false)}
              />
            )}

            {showDialog && (
              <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                zIndex: 1000
              }}>
                <div style={{
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  maxWidth: "90vw",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  marginTop: "30px"
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <h3 style={{ margin: 0 }}>AI Response - </h3>
                    <div>
                      <button onClick={handleExportToExcel} style={{ marginRight: "10px" }}>Export to Excel</button>
                      <button onClick={() => setShowDialog(false)}>Close</button>
                    </div>
                  </div>

                  {Array.isArray(answer) && (
                    <>
                      <input
                        type="text"
                        placeholder="Search..."
                        value={filterText}
                        onChange={(e) => { setFilterText(e.target.value); setCurrentPage(1); }}
                        style={{ marginBottom: "10px", padding: "5px", width: "100%" }}
                      />
                      <div style={{ overflowX: "auto" }}>
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                          <thead>
                            <tr>
                              {Object.keys(answer[0] || {}).filter(k => !["_id", "id", "log"].includes(k)).map((key) => (
                                <th key={key}
                                  onClick={() => {
                                    if (sortKey === key) {
                                      setSortAsc(!sortAsc);
                                    } else {
                                      setSortKey(key);
                                      setSortAsc(true);
                                    }
                                  }}
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f2f2f2",
                                    textTransform: "capitalize",
                                    cursor: "pointer"
                                  }}>
                                  {key} {sortKey === key ? (sortAsc ? "↑" : "↓") : ""}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedAnswer.map((item, index) => (
                              <tr key={index}>
                                {Object.entries(item).filter(([k]) => !["_id", "id", "log"].includes(k)).map(([key, value]) => {
                                  let displayValue = value;
                                  if (["price", "value", "totalPrice", "totalValue"].includes(key) && typeof value === "number") {
                                    displayValue = `£${(value / 100).toFixed(2)}`;
                                  } else if (typeof value === "object") {
                                    displayValue = JSON.stringify(value);
                                  } else {
                                    displayValue = String(value);
                                  }

                                  const isTruncatable = ["vmppNm", "amppNm"].includes(key) && displayValue.length > 25;
                                  const cellText = isTruncatable ? displayValue.slice(0, 25) + "…" : displayValue;

                                  return (
                                    <td
                                      key={key}
                                      style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        maxWidth: "200px",
                                        overflowWrap: "break-word"
                                      }}
                                      title={isTruncatable ? displayValue : ""}
                                    >
                                      {cellText}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div style={{ marginTop: "10px", textAlign: "center" }}>
                        <button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>Prev</button>
                        <span style={{ margin: "0 10px" }}>Page {currentPage} of {totalPages}</span>
                        <button onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
                      </div>
                    </>
                  )}

                  {!Array.isArray(answer) && (
                    <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                      {loadingAnswer ? "Searching..." : answer}
                    </pre>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </LocalizationProvider>
  );
};

export default App;